import { useFetchData } from "@/hooks";
import { PageHeader } from "@/components/ui";
import {
    StatCardsRow,
    RecentOrdersCard,
    RecentStockCard,
    LowStockCard,
    CashBalancesCard,
} from "./components";

const Dashboard = () => {
    const { data, isLoading } = useFetchData("dashboard/summary");

    return (
        <div className="flex flex-col gap-6">
            <PageHeader
                title="Dashboard"
                description={
                    data?.period?.month
                        ? `Ringkasan bulan ${data.period.month}`
                        : undefined
                }
            />

            {/* Row 1: Stat Cards */}
            <StatCardsRow stats={data?.stats} isLoading={isLoading} />

            {/* Row 2: Pesanan + Saldo Kas (kiri) | Stok cards (kanan) */}
            <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-3">
                <div className="flex flex-col gap-6 lg:col-span-2">
                    <RecentOrdersCard
                        orders={data?.recent_orders}
                        isLoading={isLoading}
                    />
                    <CashBalancesCard
                        balances={data?.cash_balances}
                        isLoading={isLoading}
                    />
                </div>
                <div className="flex flex-col gap-6">
                    <RecentStockCard
                        stocks={data?.recent_stock}
                        isLoading={isLoading}
                    />
                    <LowStockCard
                        stocks={data?.low_stock}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
